export default __webpack_public_path__ + "static/media/Govornik.e348e575.png";